import { getQueryString } from "../utils/helperFunctions";

export const webUrl = "https://trade.share.market";
export const loggedInUrl = `${webUrl}/support`;
export const ticketsUrl =
  "https://support-tickets.share.market/support/tickets";
export const getUrlConfig = bundleParams => ({
  WEALTH_ADD_MONEY: {
    deepLink: "phonepe-wealth://app/portfolio/home?tab=",
    webURL: webUrl,
  },
  CLOSED_ORDERS: {
    webURL: `${webUrl}/orders?orderStatus=CLOSED`,
    deepLink:
      "phonepe-wealth://app/portfolio/home?tab=orders",
  },
  CHATBOT: {
    deepLink: `${
      process.env.GATSBY_CHATBOT_URL
    }${getQueryString(bundleParams)}`,
    webURL: `${webUrl}#openbot`,
  },
});
